<template>
  <nav class="bs-foundation user-pagination" aria-label="User pages">
    <button type="button" class="item" :disabled="page <= 1" @click="$emit('select', page - 1)">Prev</button>
    <template v-for="(entry, index) in entries" :key="index">
      <span v-if="entry === null" class="disabled item" aria-hidden="true">…</span>
      <button v-else type="button" class="item" :class="{ active: entry === page }" :aria-label="'Page ' + entry" :aria-current="entry === page ? 'page' : null" @click="$emit('select', entry)">{{ entry }}</button>
    </template>
    <button type="button" class="item" :disabled="page >= pages" @click="$emit('select', page + 1)">Next</button>
  </nav>
</template>
<script>
export default {
  props: { page: { type: Number, required: true }, pages: { type: Number, required: true } },
  emits: ['select'],
  computed: { entries() {
    const result = [];
    const start = Math.max(1, Math.min(this.page - 1, this.pages - 2));
    for (let value = 1; value <= this.pages; value++) {
      if (value <= 2 || value > this.pages - 2 || (value >= start && value < start + 3)) result.push(value);
      else if (result[result.length - 1] !== null) result.push(null);
    }
    return result;
  } }
};
</script>
<style scoped>
.user-pagination { display: flex; flex-wrap: wrap; align-items: center; gap: .25rem; margin: 1rem 0; }
.item { display: inline-flex; align-items: center; justify-content: center; min-width: 44px; min-height: 44px; padding: .5rem; background: var(--bs-color-surface); color: var(--bs-color-ink); border: 1px solid var(--bs-color-rule); border-radius: var(--bs-radius-sm); font: inherit; cursor: pointer; }
.item[aria-current="page"] { background: var(--bs-color-amber-tap); font-weight: 700; }
.item:disabled { opacity: .55; cursor: not-allowed; }
span.item { min-width: 1rem; border: 0; background: transparent; cursor: default; }
</style>
